'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosUndoOutline = function IoIosUndoOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 28.8v2.5h-0.8l-1.5-2.5c-1.6-2.5-3.5-4.9-5.9-6-1.9-0.8-3.7-1.5-6.8-1.6v6.3l-15-10 15-10v6.2c4.9 0.3 8.4 1.7 11.2 4.4 4 4.2 3.8 9.3 3.8 10.7z m-1.2-0.6s0.7-13.2-15-13.2v-5.1l-11.6 7.6 11.6 7.6v-5.1c7.1 0 11.2 1.9 15 8.2z' })
        )
    );
};

exports.default = IoIosUndoOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-undo-outline.js
// module id = 2310
// module chunks = 0